<template>
    <BDropdown text="User Roles" size="sm" variant="secondary">
        <BDropdownItem v-if="userRoles.length > 0">
            <span v-for="role in userRoles" :key="role" class="badge bg-secondary text-dark me-1">
                {{ role }}
            </span>
        </BDropdownItem>
        <BDropdownItem v-else disabled>
            No roles assigned.
        </BDropdownItem>
    </BDropdown>
</template>

<script>
import { mapStores } from 'pinia'
import { useCurrentUserStore } from '@/common/stores/currentUserStore';
import { BDropdown, BDropdownItem } from 'bootstrap-vue-next';

export default {
    name: 'UserRoleProvider',
    components: {
        BDropdown,
        BDropdownItem
    },

    data() {
        return {
            userRoles: [],
        }
    },
    emits: ['user-roles-updated'],
    watch: {
        'currentUserStore.roles': function (newRoles) {
            this.userRoles = newRoles;
            this.$emit('user-roles-updated');
        },
        'currentUserStore.contactId': function (newContactId) {
            this.$emit('contact-id-updated', newContactId);
        }
    },

    computed: {
        ...mapStores(useCurrentUserStore),
    }
};
</script>
